

import Card from 'components/Layout/Card';
import Table from 'components/Layout/Table';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchConferencesList,
  fetchDetailedViewData,
  getSourceList,
  setSubmittedAbstractsDetailedView,
} from 'store/slices';
import {
  getDataFromLocalStorage,
  objectToFormData,
  titleCaseString,
} from 'utils/helpers';
import { limit } from 'utils/constants';
import { useNavigate, useParams } from 'react-router-dom';
import Button from 'components/form/Button';
import usePermission from 'hooks/usePermission';



const SubmittedAbstracts = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    membershipList,
    submittedAbstractsDetailedView: submittedAbstracts,
  } = useSelector((state) => ({
    membershipList: state.global.membershipList,
    countryList: state.global.countryList,
    conferencesList: state.global.conferencesList,
    submittedAbstractsDetailedView: state.global.submittedAbstractsDetailedView,
  }));
  const { viewAccess } = usePermission("Profile Management");
  const { memberType, moduleType, eventId, userId } = params;
  const [sourceList, setSourceList] = useState([]);
  const [tableList, setTableList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchPayload, setSearchPayload] = useState({
    paper_id: '',
    paper_title: '',
    source: '',
    member_id: '',
    member_type: '',
    author_name: '',
    author_email: '',
    payment_status: '',
    certificate_status: ''
  });
  const [filterData, setFilterData] = useState({
    total: 0,
    offset: submittedAbstracts ? submittedAbstracts : 0,
    limit: limit,
    membership_plan_id: '',
    event_id: eventId ? eventId : '',
    user_id: userId ? userId : '',
    specific_user_paper: 1
  });

  const getDetailedViewData = async (obj) => {
    let formData = new FormData();
    if (obj?.statusValue) {
      obj?.statusValue?.forEach((value) => {
        formData.append(
          `status[${obj?.statusType?.toLowerCase()}][${value}]`,
          value
        );
      });
    }
    const keysToOmit = ['statusType', 'statuss', 'statusValue', 'status'];
    for (const key in obj) {
      if (!keysToOmit.includes(key)) {
        formData.append(key, obj[key]);
      }
    }
    const response = await dispatch(fetchDetailedViewData(formData));
    setTableList(response?.data?.abstracts || []);
    setFilterData({
      ...obj,
      total: response?.data?.result_count || 0,
    });
    setIsLoading(false);
  };

  const handelChangeSearch = (searchData) => {
    setIsLoading(true);
    let newData = filterData;
    setSearchPayload(searchData);
    newData = { ...newData, ...searchData, offset: 0 };
    setFilterData(newData);
    getDetailedViewData(newData);
  };

  const handelChangePagination = (offset) => {
    setIsLoading(true);
    let newData = { ...filterData, ...searchPayload };
    newData = { ...newData, offset: offset };
    dispatch(setSubmittedAbstractsDetailedView(offset));
    setFilterData(newData);
    getDetailedViewData(newData);
  };

  // const getConferenceList = async () => {
  //   await dispatch(fetchConferencesList());
  // };

  const fetchSourceList = async () => {
    const response = await dispatch(
      getSourceList(objectToFormData({ type: 'paper' }))
    );
    setSourceList(response?.data || []);
  };

  useEffect(() => {
    getDetailedViewData({ ...filterData, ...searchPayload });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchPayload]);

  useEffect(() => {
    if (!['0', '1', '6'].includes(getDataFromLocalStorage('user_type'))) {
      navigate('/');
    }
    // getConferenceList();
    fetchSourceList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRedirect = (paperId) => {
    navigate(`/${memberType}/event-management/new-submitted-papers/${paperId}`);
  };

  let header = [
    {
      isSearch: false,
      searchInputName: 'name',
      title: 'S.No',
    },
    {
      isSearch: true,
      searchInputName: 'paper_id',
      title: 'Paper ID',
    },
    {
      isSearch: true,
      searchInputName: 'paper_title',
      title: 'Paper Title',
    },
    {
      isSearch: true,
      isSearchDropdown: true,
      dropdownOptions: { options: [{ id: '0', value: 'Un-Paid' }, { id: '1', value: 'Paid' }, { id: '2', value: 'Under-Verification' }], key: 'id', value: 'value' },
      searchInputName: 'payment_status',
      title: <div className="text-nowrap">Payment Status</div>,
    },
    {
      isSearch: true,
      isSearchDropdown: true,
      dropdownOptions: { options: [{ id: '0', value: 'Not-Download' }, { id: '1', value: 'Download' }], key: 'id', value: 'value' },
      searchInputName: 'certificate_status',
      title: <div className="text-nowrap">Certificate Status</div>,
    },
    {
      isSearch: true,
      searchInputName: 'paper_type',
      title: 'Paper Type',
    },
    {
      isSearch: true,
      isSearchDropdown: true,
      dropdownOptions: {
        options: sourceList,
        key: 'source',
        value: 'source',
      },
      searchInputName: 'source',
      title: <div className="text-nowrap ms-4 me-4">Source</div>,
    },


    {
      isSearch: true,
      searchInputName: 'member_id',
      title: <div>Member ID</div>,
    },
    {
      isSearch: true,
      isSearchDropdown: true,
      dropdownOptions: { options: membershipList, key: 'name', value: 'name' },
      searchInputName: 'member_type',
      title: <div className="text-nowrap">Member Type</div>,
    },
    {
      isSearch: true,
      searchInputName: 'author_name',
      title: 'Author',
    },
    {
      isSearch: true,
      searchInputName: 'author_email',
      title: <div className="text-nowrap">Author Email</div>,
    },


    {
      isSearch: false,
      searchLable: '',
      title: 'Action',
    },
  ];

  const rowData = [];
  tableList?.forEach((elem, index) => {
    let obj = [
      {
        value: <span>{filterData?.offset + index + 1}</span>,
      },
      {
        value: (
          <span
            className="pointer color-new-car"
            onClick={() => {
              handleRedirect(elem?.id);
            }}
          >
            {elem?.paperId || '-'}
          </span>
        ),
      },
      {
        value: (
          <div style={{ width: '200px' }}>
            {titleCaseString(elem?.paperTitle) || '-'}
          </div>
        ),
      },
      {
        value: <div className={
          elem?.payment_status === "Paid"
            ? "color-success"
            : elem?.payment_status === "Under-verification"
              ? "color-warning"
              : "color-danger-bar"
        }>{elem?.payment_status || '-'}</div>,
      },
      {
        value: <div className={
          elem?.certificate_status === "Downloaded"
            ? "color-success"
            : "color-danger-bar"
        }>{elem?.certificate_status || '-'}</div>,
      },
      {
        value: <div style={{ width: '100px' }}>{elem?.paper_type || '-'}</div>,
      },
      {
        value: <span>{elem?.submitted_from ? elem?.submitted_from : '-'}</span>,
      },

      {
        value: <div className="text-nowrap">{elem?.memberId || '-'}</div>,
      },
      {
        value: <div>{elem?.membershipCategory || '-'}</div>,
      },
      {
        value: (
          <div className="text-14-500 color-new-car" style={{ width: '150px' }}>
            {elem?.authorName
              || '-'}
          </div>
        ),
      },
      {
        value: <span className="text-14-500">{elem?.authorEmail || '-'}</span>,
      },


      {
        value: (
          <span className="action-icon-buttons align-items-center">
            <>

              {viewAccess === '1' && (
                <Button
                  btnStyle="custom-hover-button"
                  icon={<i className="bi bi-eye pointer" />}
                  onClick={() => {
                    handleRedirect(elem?.id);
                  }}
                />
              )}


            </>
          </span>
        ),
      },
    ];
    rowData.push({ data: obj });
  });

  return (
    <>
      <Card className="cp-20 cmt-10">
        <div className="d-flex justify-content-between align-items-center cpb-10">
          <div className="table-title">All Submitted Abstarct ({filterData?.total})</div>
        </div>
        <Table
          isLoading={isLoading}
          header={header}
          rowData={rowData}
          filterData={filterData}
          searchPayload={searchPayload}
          searchInputChange={handelChangeSearch}
          changeOffset={handelChangePagination}
          {...(!eventId && { isOtherPagination: true })}
          submittedAbstracts
        // maxHeight="60vh"
        />
      </Card>
    </>
  );
};

export default SubmittedAbstracts;
